'use client';
import { objectEntries } from '@s7/utils';
import { Client } from './Client.js';
import { responseTypes } from '../domain/constants.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _create_for_of_iterator_helper_loose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupported_iterable_to_array(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) {
                return {
                    done: true
                };
            }
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
/**
 * Создаёт экземпляр Client, сразу выполняет запрос, выполняет все middleware.
 *
 * Прикрепляет к Promise<Response> body-методы, которые дополнительно устанавливают Accept-заголовок.
 * Это требует откладывать запрос на 1 проход событийного цикла. См. реализацию Client.execute.
 * */ var getDecoratedResponsePromise = function(input, options) {
    var _loop = function() {
        var _step_value = _step.value, type = _step_value[0], mimeType = _step_value[1];
        result[type] = /*#__PURE__*/ _async_to_generator(function() {
            var awaitedResult, response, responseSize, text;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!client.request.headers.has("accept")) {
                            client.request.headers.set("accept", mimeType);
                        }
                        return [
                            4,
                            result
                        ];
                    case 1:
                        awaitedResult = _state.sent();
                        response = awaitedResult.clone();
                        if (!(type === "json")) return [
                            3,
                            4
                        ];
                        if (response.status === 204) {
                            return [
                                2,
                                ""
                            ];
                        }
                        return [
                            4,
                            response.clone().arrayBuffer()
                        ];
                    case 2:
                        responseSize = _state.sent().byteLength;
                        if (responseSize === 0) {
                            return [
                                2,
                                ""
                            ];
                        }
                        if (!options.parseJson) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            response.text()
                        ];
                    case 3:
                        text = _state.sent();
                        return [
                            2,
                            options.parseJson(text)
                        ];
                    case 4:
                        return [
                            2,
                            response[type]()
                        ];
                }
            });
        });
    };
    var client = Client(input, options);
    var result = client.execute();
    /*
     * @note
     * `result` не требует декорирования `response.clone` в связи с тем,
     * что здесь мы декорируем Promise<Response>, а не сам Response
     * */ for(var _iterator = _create_for_of_iterator_helper_loose(objectEntries(responseTypes)), _step; !(_step = _iterator()).done;)_loop();
    return result;
};

export { getDecoratedResponsePromise };
